import { render, staticRenderFns } from "./survey-who-pays.vue?vue&type=template&id=1c7734ab"
import script from "./survey-who-pays.vue?vue&type=script&lang=js"
export * from "./survey-who-pays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports